mutation resumeChannelForLead($input: ResumeChannelForLeadInput!) {
  resumeChannelForLead(input: $input)
}
